/**
 * Whether this browser can give us a WebGL context.
 *
 * Returns false when hardware acceleration is off, the GPU is blocklisted, or
 * WebGL is disabled by policy/flag. Used to skip downloading the Spline/three.js
 * runtime on machines that can't render it.
 */
export const isWebGLAvailable = (): boolean => {
  if (typeof window === "undefined") return false;

  try {
    const canvas = document.createElement("canvas");
    // Spline's three.js build renders with WebGL2, falling back to WebGL1.
    const gl =
      canvas.getContext("webgl2") ??
      (canvas.getContext("webgl") as WebGLRenderingContext | null);

    if (!gl) return false;

    // Free the probe context immediately - browsers cap concurrent contexts.
    gl.getExtension("WEBGL_lose_context")?.loseContext();
    return true;
  } catch {
    return false;
  }
};
